import { render, staticRenderFns } from "./HeaderZoom.vue?vue&type=template&id=99b668f6"
import script from "./HeaderZoom.vue?vue&type=script&lang=js"
export * from "./HeaderZoom.vue?vue&type=script&lang=js"
import style0 from "./HeaderZoom.vue?vue&type=style&index=0&id=99b668f6&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b668f6')) {
      api.createRecord('99b668f6', component.options)
    } else {
      api.reload('99b668f6', component.options)
    }
    module.hot.accept("./HeaderZoom.vue?vue&type=template&id=99b668f6", function () {
      api.rerender('99b668f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/HeaderZoom.vue"
export default component.exports